import { isDefined } from '@/utils/isDefined'

export function format () {
  const args = arguments

  if (args.length === 1) return args[0]

  return args[0].replace(/\{(\d+)\}/g, function (match, number) {
    const index = Number(number) + 1
    return (args[index] !== undefined ? args[index] : match)
  })
}

export function formatOffset (offsetString) {
  if (offsetString && offsetString.length > 0) {
    const offset = Number(offsetString)
    if (!isNaN(offset)) { return ` (${offset})` }
  }
  return ''
}

export function isNullOrWhiteSpace (text) {
  if (!isDefined(text)) { return true }
  return text.replace(/\s/g, '').length === 0
}

export function truncate (content, len) {
  if (typeof content !== 'string' || typeof len !== 'number' || len <= 0 || content.length <= len) return content
  return content.substring(0, len) + '...'
}



// WEBPACK FOOTER //
// ./src/utils/StringUtilities.js